import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}))

export default function ReportsTable({ reportsTable }) {
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ border: '1px solid #e6e6e6', boxShadow: 0 }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Сотрудник
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Количество заданий без просрока
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Количество заданий с просроком
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Общее время просрока (часы)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportsTable?.data?.length > 0 &&
              reportsTable?.data?.map((row) => (
                <StyledTableRow key={row.name}>
                  <TableCell align="center">{row.userName}</TableCell>
                  <TableCell align="center">
                    {row.taskData?.totalTaskCount}
                  </TableCell>
                  <TableCell align="center">
                    {row.taskData?.overdueTaskCount}
                  </TableCell>
                  <TableCell align="center">
                    {row.taskData?.totalHoursOverdue}
                  </TableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
